const transfers = {
  transfer: "ΜΕΤΑΦΟΡΑ", // translated
  transfers: "Μεταγραφές", // translated
  dateAndTime: "Ημερομηνία και ώρα", // translated
  transferFrom: "Μεταφέρω από", // translated
  duration: "Διάρκεια", // translated
  numOfPersons: "ΑΡΙΘΜΟΣ ΑΤΟΜΩΝ", // translated
  baggageAllowance: "Επιτρεπόμενες αποσκευές", // translated
  small: "Μικρό", // translated
  big: "Μεγάλο", // translated
  provider: "Προμηθευτής", // translated
  vehicle: "Οχημα", // translated
  distance: "Απόσταση", // translated
  price: "Τιμή", // translated
  inboundJourney: "Εισερχόμενο ταξίδι", // translated
  outboundJourney: "Εξωτερικό Ταξίδι", // translated
  arrivalTime: "Ωρα άφιξης", // translated
  flightDetails: "Λεπτομέρειες πτήσης", // translated
  inboundPickupDate: "Εισερχόμενη Ημερομηνία Παραλαβής", // translated
  outboundPickupDate: "Ημερομηνία Παραλαβής Εξερχόμενης", // translated
  travelInfo: "Ταξιδιωτικές Πληροφορίες", // translated
  flightsInfo: "Πληροφορίες πτήσεων", // translated
  airportYouAreFlyingFrom: "Αεροδρόμιο από το οποίο πετάτε", // translated
  airportYouAreFlyingTo: "Αεροδρόμιο στο οποίο πετάτε", // translated
  inboundFlightNumber: "Αριθμός εισερχόμενης πτήσης", // translated
  outboundFlightNumber: "Αριθμός εξερχόμενης πτήσης", // translated
  inboundAirlineName: "Όνομα εισερχόμενης αεροπορικής εταιρείας", // translated
  outboundAirlineName: "Όνομα εξερχόμενης αεροπορικής εταιρείας", // translated
  tripMode: "Λειτουργία ταξιδιού", // translated
  airportToPoint: "Airport To Point", // translated
  pointToAirport: "Σημείο προς το αεροδρόμιο", // translated
  roundTrip: "Ταξίδι μετ επιστροφής", // translated
  destinationPoint: "Σημείο προορισμού", // translated
  originPoint: "Σημείο Προέλευσης", // translated
  transferType: "Τύπος μεταφοράς", // translated
  min: "Ελάχ", // translated
  max: "Μέγιστη", // translated
  pieces: "Κομμάτια", // translated
  cancelationIs: "ακύρωση είναι", // translated
};

export default transfers;
